import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import queryString from 'query-string';
import { useLocation, useNavigate, useParams } from 'react-router';
import Metadata from '../../components/Metadata';
import TemplatesNewForm from '../../components/Templates/TemplatesNewForm';
import { Page } from '../../constants/pageTitles';

const page = `${Page['template']}`;

const TemplatesNewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { accountId, domainId } = useParams();

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/templates` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <TemplatesNewForm
              from={queryString.parse(location.search).from}
              onSuccess={() => navigate(location.pathname.replace('/templates/new', `/templates`))}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default TemplatesNewPage;
